import { GetList } from "types/data-content";
import BenefitsSection from "./components/BenefitsSection";
import CTASection from "./components/CTASection";
import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ProcessSection from "./components/ProcessSection";

interface IServicePage {
  pageData: GetList[];
}

const Index = ({ pageData }: IServicePage) => {
  return (
    <div className="min-h-screen bg-background">
      <HeroSection pageData={pageData[0]} />
      <HowItWorksSection pageData={pageData[0]} />
      <BenefitsSection pageData={pageData[0]} />
      <ProcessSection pageData={pageData[0]} />
      <CTASection pageData={pageData[0]} />
    </div>
  );
};

export default Index;
